import {
  ArrowsRightLeftIcon,
  Cog6ToothIcon,
  ChartBarIcon,
  ShieldCheckIcon,
} from '@heroicons/react/24/outline';
import { MIGRATION_SCOPE } from '../../../../content/enterpriseMessaging';

const items = [
  {
    name: 'Snowflake, Teradata & SQL Server migration',
    description:
      'Move legacy warehouses and databases into governed Snowflake, including AIM-assisted delivery, dbt models, and semantic layer migration without disrupting downstream BI.',
    icon: ArrowsRightLeftIcon,
    iconClass: 'bg-theme-migration-50 text-theme-migration-600',
  },
  {
    name: 'Semantic modeling & BI-to-data-layer',
    description:
      'Enterprise semantic models, certified metrics, legacy BI uplift, and Power BI semantic layer migration so every dashboard and agent shares the same numbers.',
    icon: ChartBarIcon,
    iconClass: 'bg-[rgba(0,18,63,0.08)] text-brand-900',
  },
  {
    name: 'AWS, Azure & platform engineering',
    description:
      'Cloud architecture, Streamlit app layers, Fabric and Amazon QuickSight integration, and data pipelines that close the context gap from ingestion to domain memory.',
    icon: Cog6ToothIcon,
    iconClass: 'bg-brand-50 text-brand-600',
  },
  {
    name: 'Analytics governance & compliance',
    description:
      'Role hierarchies, masking policies, lineage, and audit-ready controls for secure enterprise analytics and AI-ready decisions.',
    icon: ShieldCheckIcon,
    iconClass: 'bg-accent-50 text-accent-700',
  },
];

export default function Details() {
  return (
    <div className="container-x section">
      <div className="max-w-3xl">
        <p className="eyebrow">{MIGRATION_SCOPE.eyebrow}</p>
        <h2 className="mt-3 text-3xl sm:text-4xl font-semibold tracking-tight text-ink-900">
          One cohesive data-to-decision ecosystem on platforms you trust.
        </h2>
        <p className="mt-5 text-lg leading-relaxed text-ink-600">{MIGRATION_SCOPE.body}</p>
        <blockquote className="mt-6 rounded-xl border border-brand-100 bg-brand-50/50 px-5 py-4">
          <p className="text-base italic text-ink-700">&ldquo;{MIGRATION_SCOPE.quote}&rdquo;</p>
        </blockquote>
      </div>

      <dl className="mx-auto mt-12 grid max-w-none grid-cols-1 gap-x-12 gap-y-10 text-ink-700 sm:grid-cols-2">
        {items.map((item) => (
          <div key={item.name} className="relative pl-12">
            <dt className="text-base font-semibold text-ink-900">
              <span className={`absolute left-0 top-0 inline-flex h-9 w-9 items-center justify-center rounded-lg ${item.iconClass}`}>
                <item.icon aria-hidden="true" className="h-5 w-5" />
              </span>
              {item.name}
            </dt>
            <dd className="mt-2 text-ink-600 leading-7">{item.description}</dd>
          </div>
        ))}
      </dl>

      <div className="mt-12 flex justify-end">
        <a href="/contact?service=platform-engineering" className="btn-primary">Plan your analytics roadmap</a>
      </div>
    </div>
  );
}
